import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import OpportunityWizardSteps from './OpportunityWizardSteps';

interface OpportunityWizardLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  title: string;
  description: string;
  onNext?: () => void;
  onPrevious?: () => void;
  isNextDisabled?: boolean;
  isComplete?: boolean;
  nextButtonText?: string;
}

const OpportunityWizardLayout: React.FC<OpportunityWizardLayoutProps> = ({
  children,
  currentStep,
  totalSteps,
  title,
  description,
  onNext,
  onPrevious,
  isNextDisabled = false,
  isComplete = false,
  nextButtonText,
}) => {
  const navigate = useNavigate();

  const handleStepClick = (step: number) => {
    // Navegar para o step anterior quando clicado
    if (step < currentStep) {
      navigate(`../step${step}`, { relative: 'path' });
    }
  };

  return (
    <div className="w-full px-6 py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-extrabold">Nova Oportunidade</h1>
          <p className="text-muted-foreground">
            {description}
          </p>
        </div>
        
        <div>
          <Button 
            variant="outline" 
            onClick={() => navigate('/opportunities')}
            className="gap-1"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar para Oportunidades
          </Button>
        </div>
      </div>

      {/* Componente de Steps */}
      <OpportunityWizardSteps 
        currentStep={currentStep} 
        onStepClick={handleStepClick}
        className="mb-6"
      />

      <Card>
        <CardContent className="pt-6">
          {children}
        </CardContent>
      </Card>

      <div className="mt-6 flex justify-between">
        {currentStep > 1 ? (
          <Button
            variant="outline"
            onClick={onPrevious}
            className="gap-1"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Button>
        ) : (
          <Button
            variant="outline"
            onClick={() => navigate('/opportunities')}
            className="gap-1"
          >
            <ArrowLeft className="h-4 w-4" />
            Cancelar
          </Button>
        )}

        {currentStep < totalSteps ? (
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            className="gap-1"
          >
            {nextButtonText || 'Próximo'}
            <ArrowRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            className="gap-1 bg-green-600 hover:bg-green-700"
          >
            {nextButtonText || 'Finalizar'}
            <Check className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default OpportunityWizardLayout; 